"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchGraphqlError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _logger = require("@ori/logger");
/**
 * The `trimString` function takes a GraphQL query as input and returns a trimmed version of it if its
 * length exceeds 255 characters.
 * @param {string} graphqlQuery - The `trimString` function takes a `graphqlQuery` parameter, which is
 * expected to be a string. The function checks if the length of the `graphqlQuery` is greater than 255
 * characters. If it is, the function returns the first 255 characters of the `graphqlQuery`, otherwise
 * @returns If the length of the `graphqlQuery` is greater than 255 characters, the function will
 * return the first 255 characters of the `graphqlQuery`. Otherwise, it will return the original
 * `graphqlQuery` unchanged.
 */
const trimGraphqlQuery = graphqlQuery => {
  if (graphqlQuery.length > 255) {
    return graphqlQuery.slice(0, 255);
  }
  return graphqlQuery;
};

/**
 * Generic error caused by failed fetch to the graphql server
 */
class FetchGraphqlError extends _logger.FormattedAxiosError {
  constructor(axiosError, graphqlQuery) {
    super(axiosError);
    (0, _defineProperty2.default)(this, "variables", void 0);
    (0, _defineProperty2.default)(this, "graphqlQuery", void 0);
    this.name = 'FetchGraphqlError';
    const {
      config
    } = axiosError;
    this.variables = typeof config?.data === 'object' && 'variables' in config.data ? config.data.variables : null;
    this.graphqlQuery = trimGraphqlQuery(graphqlQuery);
  }
}
exports.FetchGraphqlError = FetchGraphqlError;
//# sourceMappingURL=FetchGraphqlError.js.map